"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var prop_types_1 = require("prop-types");

var index_1 = require("../../index");

require("./index.css");

var TextInput = function (_a) {
  var field = _a.field,
      form = _a.form,
      disabled = _a.disabled,
      label = _a.label,
      helperText = _a.helperText,
      helperIcon = _a.helperIcon,
      helperIconColor = _a.helperIconColor,
      iconLeft = _a.iconLeft,
      basic = _a.basic,
      error = _a.error,
      className = _a.className,
      type = _a.type,
      size = _a.size,
      listName = _a.listName,
      listOptions = _a.listOptions,
      placeholder = _a.placeholder,
      usePlaceholder = _a.usePlaceholder,
      onChange = _a.onChange,
      onBlur = _a.onBlur,
      maxLength = _a.maxLength,
      props = __rest(_a, ["field", "form", "disabled", "label", "helperText", "helperIcon", "helperIconColor", "iconLeft", "basic", "error", "className", "type", "size", "listName", "listOptions", "placeholder", "usePlaceholder", "onChange", "onBlur", "maxLength"]);

  var _b = (0, react_1.useState)(false),
      focus = _b[0],
      setFocus = _b[1];

  var containerClass = "text-input-container";

  if (className) {
    containerClass += " " + className;
  }

  if (error.length > 0) {
    containerClass += ' error';
  }

  if (focus) {
    containerClass += ' focus';
  }

  if (size) {
    containerClass += " " + size;
  }

  if (listName) {
    containerClass += ' datalist';
  }

  if (basic) {
    containerClass += ' basic';
  }

  if ((field.value || focus) && !basic) {
    containerClass += ' label-lifted';
  }

  if (field.value || focus) {
    containerClass += ' show-count';
  }

  var handleOnBlur = function () {
    setFocus(false);
    if (form) form.setFieldTouched(field.name, true);
    if (onBlur) onBlur();
  };

  var renderHelperText = function () {
    return helperText && (0, jsx_runtime_1.jsxs)("div", __assign({
      className: "helper-text"
    }, {
      children: [helperIcon && (0, jsx_runtime_1.jsx)(index_1.Icon, {
        name: helperIcon,
        className: "fill helper-icon icon-" + helperIconColor,
        width: 16
      }, void 0), helperText]
    }), void 0);
  };

  var inputType = ['text', 'number', 'email', 'tel', 'password', 'date', 'time', 'url'].indexOf(type) >= 0 ? type : 'text';
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: "text-input-fieldset fieldset",
    "data-testid": "text-input-fieldset-" + field.name
  }, {
    children: [!basic && error.length > 0 && (0, jsx_runtime_1.jsxs)("div", __assign({
      className: "a-form-error",
      "data-testid": "text-input-validation-message-" + field.name
    }, {
      children: [(0, jsx_runtime_1.jsx)(index_1.Icon, {
        name: "alert",
        className: "fill icon-error input-error-icon",
        "data-testid": field.name + "-error-icon",
        width: 16
      }, void 0), (0, jsx_runtime_1.jsx)("span", {
        children: error
      }, void 0)]
    }), void 0), (0, jsx_runtime_1.jsxs)("div", __assign({
      className: containerClass,
      "data-testid": "text-input-container"
    }, {
      children: [(0, jsx_runtime_1.jsxs)("label", __assign({
        className: "text-input-control-label",
        htmlFor: field.name,
        "data-testid": "text-input-control-label-" + field.name
      }, {
        children: [label, basic && renderHelperText()]
      }), void 0), basic && error.length > 0 && (0, jsx_runtime_1.jsxs)("div", __assign({
        className: "a-form-error",
        "data-testid": "text-input-validation-message-" + field.name
      }, {
        children: [(0, jsx_runtime_1.jsx)(index_1.Icon, {
          name: "alert",
          className: "fill icon-peach input-error-icon",
          "data-testid": field.name + "-error-icon",
          width: 16
        }, void 0), error]
      }), void 0), basic && iconLeft && (0, jsx_runtime_1.jsx)("span", __assign({
        className: "has-icon-left"
      }, {
        children: (0, jsx_runtime_1.jsx)(index_1.Icon, {
          name: iconLeft,
          className: "outline icon-grey",
          "data-testid": iconLeft + "-icon",
          width: 18
        }, void 0)
      }), void 0), (0, jsx_runtime_1.jsx)("input", __assign({
        className: "text-input",
        id: field.name,
        name: field.name,
        placeholder: basic || usePlaceholder ? placeholder : null,
        type: inputType,
        value: field.value || '',
        "data-testid": "text-input-" + field.name,
        list: listName,
        onChange: onChange || field.onChange,
        onFocus: function () {
          return setFocus(true);
        },
        onBlur: handleOnBlur,
        disabled: disabled,
        maxLength: maxLength
      }, props), void 0), maxLength && (0, jsx_runtime_1.jsx)(index_1.CharacterCount, {
        value: field.value,
        maxLength: maxLength,
        testId: field.name
      }, void 0), !basic && (0, jsx_runtime_1.jsx)("span", __assign({
        className: "edit-icon"
      }, {
        children: (0, jsx_runtime_1.jsx)(index_1.Icon, {
          name: "pencil",
          className: "fill",
          width: 20
        }, void 0)
      }), void 0), listName && (listOptions === null || listOptions === void 0 ? void 0 : listOptions.length) > 0 && (0, jsx_runtime_1.jsx)("datalist", __assign({
        id: listName,
        "data-testid": "text-input-" + field.name + "-" + listName
      }, {
        children: listOptions.map(function (listOption) {
          return (// eslint-disable-next-line jsx-a11y/control-has-associated-label
            (0, jsx_runtime_1.jsx)("option", {
              value: listOption.value
            }, listOption.key)
          );
        })
      }), void 0)]
    }), void 0), !basic && renderHelperText()]
  }), void 0);
};

TextInput.propTypes = {
  field: (0, prop_types_1.shape)({
    name: prop_types_1.string,
    value: prop_types_1.string,
    onChange: prop_types_1.func
  }).isRequired,
  maxLength: prop_types_1.number,
  disabled: prop_types_1.bool,
  label: prop_types_1.string,
  error: prop_types_1.string,
  form: prop_types_1.object,
  className: prop_types_1.string,
  helperText: prop_types_1.string,
  helperIcon: prop_types_1.string,
  helperIconColor: prop_types_1.string,
  iconLeft: prop_types_1.string,
  type: prop_types_1.string,
  basic: prop_types_1.bool,
  placeholder: prop_types_1.string,
  usePlaceholder: prop_types_1.bool,
  listName: prop_types_1.string,
  listOptions: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    key: prop_types_1.string,
    value: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number]),
    label: prop_types_1.string
  }))
};
TextInput.defaultProps = {
  field: {
    name: 'input',
    value: '',
    onChange: function () {}
  },
  maxLength: null,
  disabled: false,
  label: '',
  error: '',
  type: 'text',
  basic: false,
  className: '',
  helperText: '',
  helperIcon: '',
  helperIconColor: '',
  iconLeft: '',
  placeholder: '',
  usePlaceholder: false,
  listName: undefined,
  listOptions: undefined
};
exports.default = TextInput;